<template>
    <svg width="72" height="72" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">        
        <path
            d="M10 4c0-2.21 1.79-4 3.994-4h44.012A4.001 4.001 0 0 1 62 4v64c0 2.21-1.79 4-3.994 4H13.994A4.001 4.001 0 0 1 10 68V4zm26 65a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM14 10v52h44V10H14zm22-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
        />
    </svg>
</template>